import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ConfirmacionPago = () => {
  const location = useLocation();
  const [statusOk, setStatusOk] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();
  const { slug } = useParams();

  const { isAuthenticated, user, loading } = useSelector((s) => s.auth);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const status = searchParams.get('status');
    const externalReference = searchParams.get('external_reference');
    const origin = searchParams.get('origin');
    const isFromApp = origin === 'app';

    console.log('[CONFIRMACION-PAGO] Mount:', {
      slug,
      status,
      externalReference,
      isAuthenticated,
      userEmail: user?.email,
      loadingAuth: loading
    });

    if (status === 'approved' && externalReference) {
      setStatusOk(true);

      // Si viene de la App, redirigir automáticamente al esquema passar://
      if (isFromApp) {
        const redirectTimeout = setTimeout(() => {
          window.location.href = 'passar://checkout/success';
        }, 2000);
        return () => clearTimeout(redirectTimeout);
      }

      const timeout = setTimeout(() => {
        setErrorMessage('La compra fue aprobada, pero puede demorar en reflejarse. Revisa tu perfil en unos minutos.');

        navigate(`/${slug}/profile`, {
          state: { successMessage: '🎉 ¡Tu compra fue validada exitosamente!' }
        });
      }, 10000); // ✅ ahora sí espera

      return () => clearTimeout(timeout);
    }
    else {
      setErrorMessage('El pago no fue aprobado o falta información.');
    }
  }, [location]);

  return (
    <div className="container mx-auto px-4 py-8">
      {errorMessage && (
        <div className="text-red-500 text-center">{errorMessage}</div>
      )}
      {!errorMessage && statusOk && (
        <div className="text-green-600 text-center font-semibold">
          ¡Gracias por tu compra! Estamos confirmando tu pago...
        </div>
      )}
      {!errorMessage && !statusOk && (
        <div className="text-gray-600 text-center">Procesando tu compra...</div>
      )}
    </div>
  );
};

export default ConfirmacionPago;
